<template>
    <div class="flex flex-column md:p-4">
        <span class="H6-Medium align-self-center justify-items-center">Class request</span>

        <div class="flex flex-wrap justify-content-between align-items-center gap-2 mt-3 py-2">
            <div class="flex justify-content-start align-items-center gap-2">
                <div v-if="initialLoadingComplete" class="flex justify-center md:justify-start align-items-center">
                    <img :src="profileImageUrl" alt="Profile Image" class="profile-image" />
                </div>
                <div class="flex flex-column justify-content-start gap-2">
                    <span class="text-left Paragraph-Medium">{{ request.student || request.studentId.username }}</span>
                    <span class="Caption">{{ cleanupLables(request.grade) }}</span>
                    <span class="Caption">{{ classModelText }}</span>
                </div>
            </div>
            
            <div class="flex align-items-center gap-2">
                <ChatButton v-if="studentId && studentName" :otherUserId="studentId" :otherUserName="studentName" @open-chat="$emit('open-chat', $event)" />
                <Button label="View Profile" class="teal-button-small" @click="viewProfile" />
            </div>
        </div>

        <Divider class="w-full" />

        <div class="flex flex-column md:flex-row justify-content-between align-items-start gap-4 py-4">
            <div class="flex flex-column gap-3 w-full">
                <span class="Label">
                    <span class="Paragraph-Medium pr-2">Grade -</span>
                    {{ requestData ? cleanupLables(requestData.grade) : 'Loading...' }}
                </span>
                <span class="Label" v-if="!(requestData && requestData.otherStudents && requestData.otherStudents.length > 0)">
                    <span class="Paragraph-Medium pr-2">Subject -</span>
                    {{ requestData ? cleanupLables(requestData.subject) : 'Loading...' }}
                </span>
                <span class="Label">
                    <span class="Paragraph-Medium pr-2">Language -</span>
                    {{ requestData ? cleanupLables(requestData.language) : 'Loading...' }}
                </span>
                <span class="Label" v-if="requestData && requestData.classLocation">
                    <span class="Paragraph-Medium pr-2">Class Location -</span>
                    {{ requestData ? (cleanupLables(requestData.classLocation)) : 'Loading...' }}
                </span>
                <span class="Label" v-if="requestData && requestData.date">
                    <span class="Paragraph-Medium pr-2">Date -</span>
                    {{ requestData ? formatToDisplayDate(requestData.date) : 'Loading...' }}
                </span>
                <span class="Label">
                    <span class="Paragraph-Medium pr-2">Class Mode -</span>
                    {{ requestData ? cleanupLables(requestData.classModel) : 'Loading...' }}
                </span>
                <span class="Label text-justify" v-if="requestData && requestData.areasToImprove">
                    <span class="Paragraph-Medium pr-2">Specific areas want to improve -</span>
                    {{ requestData ? requestData.areasToImprove : 'Loading...' }}
                </span>
                <span class="Label text-justify" v-if="requestData && requestData.note">
                    <span class="Paragraph-Medium pr-2">Note -</span>
                    {{ requestData ? requestData.note : 'Loading...' }}
                </span>
            </div>

            <div class="flex flex-column gap-3 w-full">
                <!-- <span class="Label"> -->
                <span class="Lable" v-if="requestData && requestData.otherStudents && requestData.otherStudents.length > 0">
                    <span class="Paragraph-Medium pr-2">Subject -</span>
                    {{ requestData ? cleanupLables(requestData.subject) : 'Loading...' }}
                </span>
                <span class="Label" v-if="requestData && requestData.classType">
                    <span class="Paragraph-Medium pr-2">Class Type -</span>
                    {{ requestData ? cleanupLables(requestData.classType) : 'Loading...' }}
                </span>
                <span class="Label pt-2" v-if="requestData && requestData.locationAddress">
                    <span class="Paragraph-Medium pr-2">Location Address -</span>
                    {{ requestData ? (requestData.locationAddress) : 'Loading...' }}
                </span>
                <span class="Label" v-if="requestData && requestData.start && requestData.end">
                    <span class="Paragraph-Medium pr-2">Time -</span>
                    {{ requestData ? formatToDisplayTime(requestData.start) + ' - ' + formatToDisplayTime(requestData.end) : 'Loading...' }}
                </span>
                <div style="display: flex; align-items: flex-start;" v-if="requestData && requestData.otherStudents && requestData.otherStudents.length > 0">
                    <span class="Label Paragraph-Medium pr-2" style="white-space: nowrap;">
                        Other Students -
                    </span>
                    <div class="Paragraph-Medium">
                        <template v-if="requestData">
                            <div v-if="requestData.otherStudents && requestData.otherStudents.length > 0">
                                <div v-for="(student, index) in requestData.otherStudents" :key="index">
                                    {{ student }}
                                </div>
                            </div>
                            <span v-else>None</span>
                        </template>
                        <span v-else>Loading...</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Verification call section - only when the student expects a verification call -->
        <div v-if="expectVerificationCall" class="flex flex-column gap-2">
            <div class="justify-content-center align-items-center">
                <Button label="Schedule a Verification Call" class="teal-button-small w-full md:w-auto"
                    :disabled="verificationChecked" @click="visibleScheduleCall = true" />
            </div>

            <div class="verification-message">
                Get the 6-digit verification code from the student during the verification call. You will need this code
                to verify the call before scheduling the class.
            </div>

            <div class="flex align-items-start gap-2 py-3">
                <Checkbox v-model="verificationChecked" class="teal-checkbox" binary inputId="verification" />
                <label for="verification" class="Label text-left"> Verification call is done </label>
            </div>

            <div v-if="verificationChecked" class="flex flex-column gap-2 pb-4">
                <label for="verificationCode" class="Label text-left">
                    Enter the 6-digit verification code given by the student
                </label>
                <div class="flex align-items-center gap-2">
                    <InputOtp v-model="verificationCodeInput" integerOnly :length="6" variant="filled"
                        :invalid="!!verificationCodeError" />
                    <i v-if="codeVerified" class="pi pi-check-circle verification-success-icon"></i>
                </div>
                <small v-if="verificationCodeError" class="verification-error-text">{{ verificationCodeError }}</small>
                <small v-else-if="codeVerified" class="verification-success-text">
                    Verification successful! You can now schedule the class.
                </small>
            </div>
        </div>

        <div class="flex flex-wrap justify-content-start gap-3 pb-4">
            <Button label="Schedule a Class" class="teal-button-small" :disabled="scheduleDisabled" @click="scheduleClass" />
            <Button label="Reject Request" class="p-button-outlined p-button-danger" @click="confirmRejection" />
        </div>
        <ConfirmDialog></ConfirmDialog>
        <Dialog v-model:visible="visibleScheduleCall" maximizable modal header="Schedule a verification call"
            :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <p class="m-0">
                Compose an email to {{ request.student }} to schedule a verification call.
            </p>
            <div translate="no" class="notranslate">
                <Editor v-model="scheduleCallContent" />
            </div>
            <Button label="Send Email" class="teal-button-small w-full md:w-auto mt-4" @click="sendVerificationCall"
                :loading="sendingEmail" />
        </Dialog>

        <!-- Disclaimer -->
        <div class="text-center w-full max-w-xl mx-auto mt-auto pt-8 pb-4">
            <h3 class="disclaimer-heading text-lg font-semibold mb-2" style="color: #1FC9A3;">Disclaimer</h3>
            <p class="text-700 text-sm m-0">
                ILearn'd Tutors enforces strict child protection policies. All communication must remain on the platform and may be monitored for safety.
            </p>
        </div>

    </div>
</template>

<script setup>
import Button from "primevue/button";
import Divider from "primevue/divider";
import Checkbox from "primevue/checkbox";
import InputOtp from "primevue/inputotp";
import { defineEmits, defineProps, ref, watch, onMounted, computed } from "vue";
import * as api from '@/api/tutor';
import { notifyError, notifySuccess } from "@/utils/notification";
import { useConfirm } from "primevue/useconfirm";
import { ConfirmDialog, Dialog } from "primevue";
import { useRouter } from "vue-router";
import Editor from 'primevue/editor';
import { verificationCallEmailTemplate } from "@/utils/options";
import { useAuthStore } from "@/stores/authStore";
import { cleanupLables, formatToDisplayDate, formatToDisplayTime } from "@/utils/cleanups";
import { generateSignedUrl } from "@/api/storage";
import blankProfile from '@/assets/blank-profile.png';
import ChatButton from "@/components/ChatButton.vue";

const authStore = useAuthStore();
const router = useRouter();

// --- PROPS & EMITS ---
const props = defineProps({
    request: {
        type: Object,
        required: true,
    },
});
const emit = defineEmits(['view-class', 'class-rejected', 'open-chat']);


// --- STATE ---
const requestData = ref(null);
const verificationChecked = ref(false);
const expectVerificationCall = ref(false);
const verificationCode = ref(null);
const verificationCodeInput = ref("");
const verificationCodeError = ref("");
const codeVerified = ref(false);
const initialLoadingComplete = ref(false);
const visibleScheduleCall = ref(false);
const sendingEmail = ref(false);
const scheduleCallContent = ref(verificationCallEmailTemplate(props.request.student, authStore.user.firstName));
const confirm = useConfirm();
const profileImageUrl = ref('');

// --- COMPUTED ---
const classModelText = computed(() => {
    if (!requestData.value) return 'Loading...';
    if (requestData.value.classModel === 'individual_class') return 'Individual Class';
    if (requestData.value.classModel === 'group_class') return 'Group Class';
    return cleanupLables(requestData.value.classModel);
});

const studentId = computed(() => {
    if (requestData.value?.studentId?._id) return requestData.value.studentId._id;
    const sid = props.request?.studentId;
    return (sid && typeof sid === 'object') ? sid._id : sid;
});

const studentName = computed(() => {
    if (requestData.value?.studentId?.username) return requestData.value.studentId.username;
    return props.request?.student || props.request?.studentId?.username;
});

const scheduleDisabled = computed(() => {
    return expectVerificationCall.value && !codeVerified.value;
});

// --- METHODS ---
const fetchRequestDetails = async (classId) => {
    try {
        const response = await api.fetchClassRequest(classId);
        requestData.value = response.data.data;
        verificationChecked.value = requestData.value.verificationCallDone || false;
        expectVerificationCall.value = requestData.value.expectVerificationCall || false;
        verificationCode.value = requestData.value.verificationCode || null;
        if (requestData.value.studentId.profilePhotoURL) {
            profileImageUrl.value = await generateSignedUrl(requestData.value.studentId.profilePhotoURL);
        } else {
            profileImageUrl.value = blankProfile; // Or a path to a blank profile image
        }
        initialLoadingComplete.value = true;
    } catch (error) {
        console.error("Error fetching class request details:", error);
        requestData.value = null;
    }
};

const scheduleClass = () => {
    if (requestData.value && requestData.value._id) {
        emit('view-class', requestData.value);
    } else {
        notifyError("Unable To Proceed!", "Class data is not loaded properly. Please try again!");
    }
};

const rejectRequest = async () => {
    try {
        await api.rejectRequest(requestData.value._id);
        notifySuccess("Success", "Request Rejected!");
        emit('class-rejected');
    } catch (e) {
        notifyError("Unable To Complete!", "Sorry! This is an unexpected error. Please try again!")
    }
}

const confirmRejection = () => {
    confirm.require({
        message: 'Do you want to reject this request?',
        header: 'Danger Zone',
        icon: 'pi pi-info-circle',
        rejectLabel: 'Cancel',
        rejectProps: {
            label: 'Cancel',
            severity: 'secondary',
            outlined: true
        },
        acceptProps: {
            label: 'Reject Request',
            severity: 'danger'
        },
        accept: () => {
            rejectRequest();
        },
        reject: () => {

        }
    });
}

const viewProfile = () => {
    const id = requestData.value.studentId._id;
    router.push(`/studentProfile/${id}`);
}

const sendVerificationCall = async () => {
    try {
        sendingEmail.value = true;
        const payload = {
            messageContent: scheduleCallContent.value
        }
        await api.sendVerificationEmail(requestData.value._id, payload);
        notifySuccess("Success", "Student has been notified!");
        sendingEmail.value = false;
        visibleScheduleCall.value = false;
    } catch {
        notifyError("Unable To Complete!", "Sorry! This is an unexpected error. Please try again!")
        sendingEmail.value = false;
    }
}
// --- WATCHERS & LIFECYCLE ---
watch(() => props.request, (newRequest) => {
    if (newRequest && newRequest._id) {
        fetchRequestDetails(newRequest._id);
    }
}, { immediate: true });

watch(verificationChecked, async (val) => {
    if (!val) {
        verificationCodeInput.value = "";
        verificationCodeError.value = "";
        codeVerified.value = false;
    }
    if (initialLoadingComplete.value) {
        await api.toggleVerificationCallStatus(requestData.value._id);
    }
});

watch(verificationCodeInput, (val) => {
    if (!val || val.length < 6) {
        codeVerified.value = false;
        verificationCodeError.value = "";
        return;
    }
    if (val === String(verificationCode.value)) {
        codeVerified.value = true;
        verificationCodeError.value = "";
    } else {
        codeVerified.value = false;
        verificationCodeError.value = "The verification code does not match. Please confirm the code with the student.";
    }
});


// Optional: Fetch data on mount if the prop is already available
onMounted(() => {
    if (!requestData.value && props.request && props.request._id) {
        fetchRequestDetails(props.request._id);
    }
});
</script>

<style scoped>
.p-button-danger {
    padding: 5px 16px 5px 16px;
    font-size: 14px;
}

.text-gray-700 {
    color: var(--gray-700) !important;
    padding-top: 30vh;
}

.align-items-start {
    align-items: flex-start;
}

.verification-message {
    background: #e0f2fe;
    border: 1px solid #bae6fd;
    color: #0369a1;
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
    line-height: 1.3rem;
}

.verification-error-text {
    color: #dc2626;
    font-size: 0.8rem;
}

.verification-success-text {
    color: #059669;
    font-size: 0.8rem;
}

.verification-success-icon {
    color: #059669;
    font-size: 1.25rem;
}
</style>